module.exports = __webpack_public_path__ + "img/img_3.b2297f35.png";